import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/finally';
import { ActiveModal, ModalService } from '../../../modals';
import { WidgetFactoryService } from '../../services/widget-factory.service';
import { Buttons } from '../../../modals/classes/buttons';

@Component({
    selector: 'chassis-core-dashboards-add-widget-modal',
    templateUrl: 'add-widget.modal.html',
    styleUrls: [ 'add-widget.modal.scss' ]
})
export class AddWidgetModal implements OnInit {

    /**
     * The Loading instance.
     *
     * @type {any}
     */
    public loading: any;

    public widgets = [];

    constructor(protected modal: ActiveModal, protected widgetService: WidgetFactoryService, protected modalService: ModalService) {
    }

    ngOnInit() {
        this.widgets = this.widgetService.all();

        const buttons = this.modal.get<Buttons>('buttons');
    }

    protected openAddWidgetModal() {
        const modal = this.modalService.open(AddWidgetModal, {}, {
            classes: 'slide-top'
        });

        modal.closed((value) => {

        });
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/modals/add-widget-modal/add-widget.modal.ts